import { useLocation } from 'quartz-routing/react-router';
import { PLAYLIST_SEARCH_PARAM } from './playlistContentConsts';
export const usePlaylistIdFromSearch = () => {
  const {
    search
  } = useLocation();
  const params = new URLSearchParams(search);
  const playlistIdSearchString = params.get(PLAYLIST_SEARCH_PARAM);
  if (playlistIdSearchString) return parseInt(playlistIdSearchString, 10);
  return undefined;
};